// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge/Type/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateClaim_Charges_Charge_Type_Content(
  $id: numeric!
  $object: vaxiom_misc_fee_charge_templates_set_input!
) {
  update_vaxiom_misc_fee_charge_templates_by_pk(
    pk_columns: { id: $id }
    _set: $object
  ) {
    id
    name
    price
    insurance_code_id
    affecting_production_report
    is_included_in_insurance_claim
    requires_tooth_details
    sys_created
    sys_last_modified
    insurance_code {
      id
      code
      title
    }
  }
}

`